import baseTheme from './PippoTheme';

const theme = {
  headerMaterialDark: '#240b36',
  headerMaterialLight: '#c31432',
};

export default { ...baseTheme, ...theme };
